import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { OptionEntity } from './optionApi';
import { RootState } from './store';

const initialState: Record<number, OptionEntity> = {};

export const optionSlice = createSlice({
  name: 'option',
  initialState,
  reducers: {
    setOption: (state, action: PayloadAction<OptionEntity>) => {
      state[action.payload.id] = action.payload;
    },
    setOptions: (state, action: PayloadAction<OptionEntity[]>) => {
      const newState: Record<number, OptionEntity> = {};
      for (const option of action.payload) {
        newState[option.id] = option;
      }
      return newState;
    },
  },
});

export const { setOption, setOptions } = optionSlice.actions;

export const selectOption = (id: number) => (state: RootState) => {
  return state.option[id];
};

export const selectOptions = (state: RootState) => {
  return state.option;
};

export const selectOptionCount = (state: RootState) => {
  return Object.keys(state.option).length;
};

export default optionSlice.reducer;
